import React from 'react';

const Sidebar = ({ categories, activeCategory, activeEndpoint, onSelectEndpoint, isDarkMode = false }) => {
  return (
    <div className="p-4">
      <nav className="space-y-2">
        {Object.entries(categories).map(([key, category]) => (
          <div key={key} className="mb-4">
            <h3 className={`text-sm font-semibold uppercase tracking-wider mb-2 ${
              isDarkMode ? 'text-slate-400' : 'text-gray-600'
            }`}>
              {category.name}
            </h3>
            <div className="space-y-1">
              {category.endpoints.map((endpoint) => (
                <button
                  key={endpoint.id}
                  onClick={() => onSelectEndpoint(key, endpoint.id)}
                  className={`w-full text-left px-3 py-2 text-sm rounded-md transition-colors flex items-center justify-between group ${
                    activeCategory === key && activeEndpoint === endpoint.id
                      ? isDarkMode 
                        ? 'bg-indigo-600 text-white font-medium shadow-sm' 
                        : 'bg-blue-50 text-blue-700 font-medium'
                      : isDarkMode
                      ? 'text-slate-300 hover:bg-slate-700 hover:text-white'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  }`}
                >
                  <span className="truncate">{endpoint.name}</span>
                  <span className={`text-xs px-2 py-1 rounded font-medium uppercase ${
                    endpoint.method === 'GET' 
                      ? isDarkMode ? 'bg-emerald-600 text-emerald-100' : 'bg-green-100 text-green-700'
                      : endpoint.method === 'POST'
                      ? isDarkMode ? 'bg-blue-600 text-blue-100' : 'bg-blue-100 text-blue-700'
                      : endpoint.method === 'PUT'
                      ? isDarkMode ? 'bg-amber-600 text-amber-100' : 'bg-yellow-100 text-yellow-700'
                      : endpoint.method === 'DELETE'
                      ? isDarkMode ? 'bg-red-600 text-red-100' : 'bg-red-100 text-red-700'
                      : isDarkMode ? 'bg-slate-600 text-slate-100' : 'bg-gray-100 text-gray-700'
                  }`}>
                    {endpoint.method}
                  </span>
                </button>
              ))}
            </div>
          </div>
        ))}
      </nav>
    </div>
  );
};

export default Sidebar;
